import { normalizeSuggestionCandidateCount } from "./schema.ts";

export function suggestionReturnInstruction(candidateCount: number | undefined): string {
  const count = normalizeSuggestionCandidateCount(candidateCount);
  return count === 1
    ? "Return zero or one suggestion as JSON."
    : `Return zero or up to ${count} candidate suggestions as JSON.`;
}
